/**
 * 弹出复制结果弹窗
 * @param {String} txt 提示内容
 */
export function alertCopyResult(txt) {
  if (document.querySelector(".copy-result-toast")) {
    console.log("找到了");
    document.querySelector(".copy-result-toast").remove();
  }
  const div = document.createElement("div");
  div.textContent = txt;
  div.classList.add("copy-result-toast");
  document.body.appendChild(div);
  setTimeout(() => {
    div.remove();
  }, 1500);
}

/**
 * 防抖函数
 * @param {Function} fn 处理的函数
 * @param {Number} wait 等待的时间
 * @returns 触发事件回调时执行的函数 
 */
export function debounce(fn, wait = 50) {
  let timer = null;
  return function (...args) {
    const context = this;
    if (timer) clearTimeout(timer);
    timer = setTimeout(() => {
      fn.apply(context, args);
    }, wait)
  }
} 
